<div class="container-fluid reset-container">
    <div class="row reset-wrapper">
      <!-- Left Image Section (Desktop) -->
      <div class="col-lg-7 d-none d-lg-block image-container">
        <img src="https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Reset-Password.png" alt="Reset Password">
      </div>
  
      <!-- Reset Password Form Section -->
      <div class="col-lg-5 col-12 d-flex align-items-center justify-content-center reset-form-container">
        <div class="reset-box glass-effect">
          <h3 class="reset-heading">Reset Password</h3>
  
          <!-- Password Rules Section -->
          <div class="password-instructions">
            <p class="reset-description">When creating your new password, please ensure it has:</p>
            <ul class="password-rules">
              <li [class.valid]="passwordValidations.minLength">Minimum 8 characters</li>
              <li [class.valid]="passwordValidations.hasSpecialChar">At least 1 special character (e.g. *#)</li>
              <li [class.valid]="passwordValidations.hasUpperLowerCase">Both upper and lower case characters</li>
              <li [class.valid]="passwordValidations.hasNumber">At least 1 number</li>
              <li [class.valid]="passwordValidations.passwordsMatch">Passwords match</li>
            </ul>
          </div>
  
          <form [formGroup]="forgotPasswordForm">
            <ng-container>
              <div class="form-group">
                <input type="password" formControlName="current_password" class="form-control" placeholder="Temporary Password*">
              </div>
              <div class="form-group">
                <input type="password" formControlName="password" class="form-control" placeholder="Password*">
              </div>
              <div class="form-group">
                <input type="password" formControlName="confirm_password" class="form-control" placeholder="Confirm Password*">
              </div>
              <div class="text-center mt-3">
                <button class="btn btn-lite-blue" (click)="changePassword()" 
                  [disabled]="!forgotPasswordForm.valid || !passwordValidations.passwordsMatch">
                  Confirm
                </button>
              </div>
            </ng-container>
          </form>
  
          <div class="text-center back-link">
            <a (click)="backTosignIn()">Back to Sign In</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  